import { render, staticRenderFns } from "./DynamicChart.vue?vue&type=template&id=b1206668&"
import script from "./DynamicChart.vue?vue&type=script&lang=js&"
export * from "./DynamicChart.vue?vue&type=script&lang=js&"
import style0 from "./DynamicChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports